import { render, staticRenderFns } from "./QCDisplay.vue?vue&type=template&id=20cdb87e&"
import script from "./QCDisplay.vue?vue&type=script&lang=js&"
export * from "./QCDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QCDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports